<template>
  <div class="flex flex-col gap-2">
    <div class="flex flex-col xs:flex-row xs:items-center xs:gap-2">
      <div class="flex items-start gap-2 pb-3 xs:flex-1 xs:items-center xs:pb-0">
        <CloseButton
          :closeTarget="closeTarget"
          class="shrink-0"
          @on-close="$emit('onClose')"
        />
        <div class="flex flex-col min-w-0">
          <div
            v-if="pageDescriptor"
            class="m-0 uppercase font-semibold tracking-wider text-xxs color-text-light"
          >
            {{ pageDescriptor }}
          </div>
          <div class="m-0 color-primary font-semibold text-m line-clamp-2">
            {{ pageTitle }}
          </div>
          <div v-if="$slots.subtitle" class="mt-0.5 min-w-0">
            <slot name="subtitle" />
          </div>
        </div>
        <div v-if="$slots.titleTrailing" class="ms-auto shrink-0">
          <slot name="titleTrailing" />
        </div>
      </div>
      <div
        v-if="$slots.actions"
        class="flex flex-col gap-2 pt-3 border-t border-color-medium-light xs:flex-row xs:flex-wrap xs:items-center xs:flex-none xs:pt-0 xs:border-t-0 xs:justify-end [&_.custom-ion-button]:w-full xs:[&_.custom-ion-button]:w-auto"
      >
        <slot name="actions" />
      </div>
    </div>
    <slot v-if="$slots.footer" name="footer" />
  </div>
</template>

<script lang="ts">
import CloseButton from "@/components/atoms/CloseButton.vue";
import { CloseTargetType } from "@/types/componentType";
import { PropType, defineComponent } from "vue";

export default defineComponent({
  name: "PageHeaderBar",
  components: { CloseButton },
  props: {
    pageTitle: { type: String, required: true },
    pageDescriptor: { type: String, default: null },
    // `null` → the back button navigates nowhere and emits `onClose` for the caller to handle.
    closeTarget: { type: String as PropType<CloseTargetType>, default: "previous" },
  },
  emits: ["onClose"],
});
</script>
